module.exports = __webpack_public_path__ + "static/media/earn.626e095b.svg";